/**
 * Read an account-recovery magic-link token (`?recover=…`) from the launch URL
 * and strip it from the address bar so a refresh can't replay it. Returns the
 * token, or null. Call once at startup (mirrors the join-code / session_id
 * launch-param readers).
 */
export function readLaunchRecoveryToken(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    const u = new URL(window.location.href);
    const token = u.searchParams.get('recover');
    if (!token) return null;
    u.searchParams.delete('recover');
    const qs = u.searchParams.toString();
    window.history.replaceState({}, '', u.pathname + (qs ? `?${qs}` : ''));
    return token;
  } catch {
    return null;
  }
}
